import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
  RichTextAdvancedSchema,
  StyledDrawerCollapse,
  WidgetType,
  type IWidgetComponentProps,
} from '@framework/engine';
import { FormItem, SelectInput } from '@framework/form';
import { yup } from '@framework/validation';
import { Card, Collapse } from 'antd';
import { CandidateColumns } from '../candidate/table/CandidateColumns';
import { ConfigCardPanelContainer } from '../candidate/ConfigCardPanelContainer';
import { ElectoralListOrderInput } from './config/ElectoralListOrderInput';
import type { IElectoralListChooserWidget } from './IElectoralListChooserWidget';

const { Panel } = Collapse;

// Colonne membro selezionabili: derivate da CandidateColumns escludendo i campi
// interni non rilevanti per il votante, così valori ed etichette restano
// allineati all'unica fonte.
const memberColumnOptions = CandidateColumns.filter(
  c => !['id', 'ordine', 'isCandidato'].includes(c.name),
).map(c => ({ value: c.name, label: c.label }));

export const ElectoralListChooserWidgetConfigSchema: yup.ObjectSchema<IElectoralListChooserWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.ElectoralListChooser).required(),
    electoralListIds: yup
      .array(yup.string().required())
      .min(1)
      .label('Liste elettorali')
      .required(),
    columns: yup
      .array(yup.string().required())
      .default(() => ['nome', 'cognome', 'dataNascita'])
      .min(1)
      .label('Colonne')
      .optional(),
    showPanel: yup.boolean().required().default(false),
    panelTitle: RichTextAdvancedSchema.optional(),
  })
    .required()
    .noUnknown();

export interface IElectoralListChooserWidgetConfigComponentProps
  extends IWidgetComponentProps<IElectoralListChooserWidget> {}

/**
 * Componente di configurazione del widget di scelta lista elettorale.
 */
export function ElectoralListChooserWidgetConfigComponent(
  props: Readonly<IElectoralListChooserWidgetConfigComponentProps>,
) {
  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'chooser']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <CommonConfigComponent {...props} hideConfigDefaultValue />
      </Panel>
      <Panel header="Impostazioni Scelta Lista" key="chooser">
        <FormItem name="electoralListIds" label="Liste elettorali">
          <ElectoralListOrderInput
            name="electoralListIds"
            style={{ width: '100%' }}
          />
        </FormItem>
        <ConfigCardPanelContainer />
        <Card
          size="small"
          title="Configura le colonne della tabella di selezione"
        >
          <FormItem
            name="columns"
            label="Campi da visualizzare nell'elenco"
            help="Seleziona i campi da mostrare per ogni candidato nell'elenco della lista elettorale."
          >
            <SelectInput
              name="columns"
              mode="multiple"
              options={memberColumnOptions}
              placeholder="Inserisci i campi da visualizzare..."
            />
          </FormItem>
        </Card>
      </Panel>
    </StyledDrawerCollapse>
  );
}
